// POP-3219: create separate node types and delete this logic
/* eslint-disable consistent-return */
import React from 'react';

import EmailConfirmation from 'src/viewLayer/components/nodes/PageNode/EmailConfirmation';
import LanguageSelection from 'src/viewLayer/components/nodes/PageNode/LanguageSelection';
import { InfoPage } from './InfoPage';
import type { PageNodePropsType } from './types';

import './index.scss';

export const PageNode = ({
  nodeConfig, goToNextNode, userData, userInput
}: PageNodePropsType): JSX.Element => {
  const {
    pageType = 'default',
    variables = {},
    options
  } = nodeConfig;

  if (pageType === 'emailConfirmation') {
    return (
      <EmailConfirmation
        nodeConfig={nodeConfig}
        goToNextNode={goToNextNode}
        email={userData?.email}
      />
    );
  }

  if (pageType === 'languageSelection') {
    return (<LanguageSelection nodeConfig={nodeConfig} />);
  }

  if (pageType === 'infoPage') {
    return (
      <InfoPage
        variables={variables}
        goToNextNode={goToNextNode}
        pageType={pageType}
        userInput={userInput}
        options={options}
      />
    );
  }
};
